import * as React from 'react'
import debounce from 'lodash.debounce'
import { StoreContext } from '@context/store-context'
import { formatPrice } from '@utils/format-price'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getShopifyImage } from 'gatsby-source-shopify'
// import DeleteIcon from "@icons/delete"
import { NumericInput } from '@ui/NumericInput/NumericInput'
import './LineItem.less'

export function LineItem({ item }) {
  const { removeFromCart, cart, updateQuantity, operationLoading } =
    React.useContext(StoreContext)
  const [quantity, setQuantity] = React.useState(item.quantity)
  // const slug = `/products/${item.merchandise?.product?.handle}`
  if (!item.merchandise) {
    return null
  }
  const variantImage = {
    ...item.merchandise?.product?.featuredImage,
    originalSrc: item.merchandise?.product?.featuredImage?.url,
  }
  const price = formatPrice(
    item.cost?.totalAmount?.currencyCode,
    Number(item.cost?.totalAmount?.amount) / quantity,
  )

  const subtotal = formatPrice(
    item.cost?.totalAmount?.currencyCode,
    Number(item.cost?.totalAmount?.amount),
  )

  const onRemove = () => {
    removeFromCart(item.id)
  }

  const uli = debounce((value) => updateQuantity(item.id, value), 300)
  // eslint-disable-next-line
  const debouncedUli = React.useCallback((value) => uli(value), [])

  const handleQuantityChange = (value) => {
    if (value !== '' && Number(value) < 1) {
      return
    }
    setQuantity(value)
    if (Number(value) >= 1) {
      debouncedUli(value)
    }
  }

  function doIncrement() {
    handleQuantityChange(Number(quantity || 0) + 1)
  }

  function doDecrement() {
    handleQuantityChange(Number(quantity || 0) - 1)
  }

  const image = React.useMemo(
    () =>
      getShopifyImage({
        image: variantImage,
        layout: 'constrained',
        crop: 'contain',
        width: 160,
        height: 160,
      }),
    [variantImage.originalSrc],
  )

  return (
    <li className="flex py-6">
      <div className="size-24 shrink-0 overflow-hidden rounded-md border border-gray-200">
        {image && (
          <GatsbyImage
            key={variantImage.originalSrc}
            image={image}
            alt={variantImage.altText ?? item.merchandise?.title}
          />
        )}
      </div>
      <div className="ml-4 flex flex-1 flex-col">
        <div>
          <div className="flex justify-between text-base font-medium text-gray-900">
            <h3>{item.merchandise?.product?.title}</h3>
            <p className="ml-4">{subtotal}</p>
          </div>
          <p className="mt-1 text-sm text-gray-500">
            {item.merchandise?.title === 'Default Title'
              ? ''
              : item.merchandise?.title}
          </p>
        </div>
        <div className="flex flex-1 items-end justify-between text-sm">
          <div className="text-gray-500">
            {/* Qty: {quantity} */}
            <NumericInput
              disabled={operationLoading.cart}
              label={`Qty:${quantity}`}
              value={quantity}
              aria-label="Quantity"
              onIncrement={doIncrement}
              onDecrement={doDecrement}
              onChange={(e) => handleQuantityChange(e.currentTarget.value)}
            />
          </div>

          <div className="flex">
            <button
              type="button"
              className="font-medium text-indigo-600 hover:text-indigo-500"
              onClick={onRemove}
              disabled={operationLoading.cart}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    </li>
    // <tr>
    //   <td>
    //     {image && (
    //       <GatsbyImage
    //         key={variantImage.src}
    //         image={image}
    //         alt={variantImage.altText ?? item.variant.title}
    //       />
    //     )}
    //   </td>
    //   <td>
    //     <h2 className="title">{item.title}</h2>
    //     <div className="variant">
    //       {item.variant.title === "Default Title" ? "" : item.variant.title}
    //     </div>
    //     <div className="remove">
    //       <button onClick={onRemove}>
    //         <DeleteIcon /> Remove
    //       </button>
    //     </div>
    //   </td>
    //   <td className="price-column">{"price, Stay Tuned! "}</td>
    //   <td>
    //     <NumericInput
    //       disabled={loading}
    //       value={quantity}
    //       aria-label="Quantity"
    //       onIncrement={doIncrement}
    //       onDecrement={doDecrement}
    //       onChange={(e) => handleQuantityChange(e.currentTarget.value)}
    //     />
    //   </td>
    //   <td className="totals">{subtotal}</td>
    // </tr>
  )
}
